"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _helpers = _interopRequireDefault(require("../helpers"));
var _logger = _interopRequireDefault(require("../logger"));
var _signalr = require("@microsoft/signalr");
var _uuid = require("uuid");
var _encryption = _interopRequireDefault(require("../encryption"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Core = exports["default"] = /*#__PURE__*/function () {
  function Core(appName, url) {
    (0, _classCallCheck2["default"])(this, Core);
    this.randomNumber = this.generateRandomString(5);
    this.appName = "".concat(appName, "-").concat(this.randomNumber);
    this.url = url || "http://127.0.0.1:5000/centralHub";
    this.connection = null;
    this.on = this.on.bind(this);
    this._events = {};
    this.cryptoKey = {};
    this.publicKey = "";
    this.services = {};
    this.coreReady = false;
    // Only exchange symmetric keys with `dpm` and `pocket`
    this.myServices = ["dpm", "pocket", "relay", "lfr"];
    this.serviceNotificationTimestamp = null;
    this.lastServiceNotificationRequestUuid = null;
  }
  return (0, _createClass2["default"])(Core, [{
    key: "on",
    value: function on(event, callback) {
      var handlers = this._events[event] || [];
      handlers.push(callback);
      this._events[event] = handlers;
    }
  }, {
    key: "generateRandomString",
    value: function generateRandomString(length) {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  }, {
    key: "trigger",
    value: function trigger(event, data) {
      var handlers = this._events[event];
      if (!handlers || handlers.length === 0) {
        return;
      }
      [].forEach.call(handlers, function (handler) {
        handler(data);
      });
    }
  }, {
    key: "getNxGTerminalToken",
    value: function () {
      var _getNxGTerminalToken = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this = this;
        var service, uuid, origin, timestamp, payload, _t2;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              service = this.services["relay"];
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context2.prev = 1;
              _context2.next = 2;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(service, {
                command: "System.Relay.GetNxGTerminalToken",
                params: {}
              }, uuid, origin, timestamp);
            case 2:
              payload = _context2.sent;
              _context2.next = 3;
              return this.connection.invoke("messaging", payload);
            case 3:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                _this.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(msg) {
                    var decrypted, parsed, _t;
                    return _regenerator["default"].wrap(function (_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          if (!(msg.action === "System.SDK.ServiceCall" && msg.requestUuid === uuid)) {
                            _context.next = 4;
                            break;
                          }
                          _context.prev = 1;
                          _context.next = 2;
                          return _encryption["default"].decryptSymmetrically(service, msg.data);
                        case 2:
                          decrypted = _context.sent;
                          parsed = JSON.parse(decrypted);
                          resolve(parsed.params);
                          _context.next = 4;
                          break;
                        case 3:
                          _context.prev = 3;
                          _t = _context["catch"](1);
                          reject(new Error("Failed to decrypt NxG token response"));
                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee, null, [[1, 3]]);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](1);
              throw new Error("Error sending encrypted request to Relay: " + _t2.message);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 4]]);
      }));
      function getNxGTerminalToken() {
        return _getNxGTerminalToken.apply(this, arguments);
      }
      return getNxGTerminalToken;
    }()
  }, {
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(message) {
        var _this2 = this;
        var _message$action, msgTs, cutoff, now, withinGracePeriod, isSymmetricKeyExchange, isNotification, dataMsg, _this$services$relay, decryptedData, enc, decryptedObject, data, _t3, _t4, _t5, _t6;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              if (!(this.serviceNotificationTimestamp !== null)) {
                _context4.next = 4;
                break;
              }
              msgTs = BigInt(message.timestamp || 0);
              cutoff = BigInt(this.serviceNotificationTimestamp);
              now = BigInt(Date.now()) * 1000000n;
              withinGracePeriod = now - cutoff < 5000000000n; // 5 seconds in nanoseconds
              isSymmetricKeyExchange = (_message$action = message.action) === null || _message$action === void 0 ? void 0 : _message$action.endsWith("SymmetricKeyExchange");
              isNotification = message.action === "System.Relay.Notifications";
              if (!(isSymmetricKeyExchange && msgTs < cutoff)) {
                _context4.next = 2;
                break;
              }
              _logger["default"].debug("LPSv2", "Rejected SYMMETRIC KEY EXCHANGE message from ".concat(message.origin, " \u2014 too old. ts=").concat(msgTs, ", cutoff=").concat(cutoff, ", action=").concat(message.action));
              return _context4.abrupt("return");
            case 2:
              if (!(!isSymmetricKeyExchange && !isNotification && withinGracePeriod && msgTs < cutoff)) {
                _context4.next = 3;
                break;
              }
              _logger["default"].debug("LPSv2", "Rejected EARLY message from ".concat(message.origin, " \u2014 within grace period. ts=").concat(msgTs, ", cutoff=").concat(cutoff, ", action=").concat(message.action));
              return _context4.abrupt("return");
            case 3:
              // Optional: log once when grace period ends
              if (!withinGracePeriod && !this._gracePeriodEndedLogged) {
                _logger["default"].info("LPSv2", "Grace period for regular messages has ended.");
                this._gracePeriodEndedLogged = true;
              }
            case 4:
              _t3 = message.action;
              _context4.next = _t3 === 'System.Relay.Notifications' ? 5 : _t3 === 'System.SDK.ServiceNotification.Response' ? 6 : _t3 === 'System.SDK.SymmetricKeyExchange' ? 11 : _t3 === 'System.ServiceNotification' ? 18 : 24;
              break;
            case 5:
              dataMsg = JSON.parse(message.data);
              this.trigger('deviceStateChange', dataMsg);
              return _context4.abrupt("return");
            case 6:
              // Accept ServiceNotification.Response even if requestUuid doesn't match
              // This handles responses to our workaround ServiceNotification messages
              if (message.requestUuid !== this.lastServiceNotificationRequestUuid) {
                _logger["default"].info("ServiceNotification", "Accepting ServiceNotification.Response with different requestUuid (likely from workaround): got=".concat(message.requestUuid, ", expected=").concat(this.lastServiceNotificationRequestUuid));
              }
              if (this.myServices.includes(message.origin)) {
                _context4.next = 7;
                break;
              }
              console.warn("Ignoring ServiceNotification Response for: ".concat(message.origin));
              return _context4.abrupt("return");
            case 7:
              _context4.prev = 7;
              this.services[message.origin] = JSON.parse(message.data);
              // Start symmetric key exchange since we received a response to our ServiceNotification
              _context4.next = 8;
              return this.startSymmetricKeyExchange(message.origin);
            case 8:
              _logger["default"].success("ServiceNotification", "Received service data from ".concat(message.origin), message.origin);
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
                _logger["default"].success("Initialization done", "Module is now ready", "Pocket");
              }
              if ((_this$services$relay = this.services["relay"]) !== null && _this$services$relay !== void 0 && _this$services$relay.symmetricKey && !this.coreReady) {
                this.coreReady = true;
                setTimeout(function () {
                  _this2.trigger("coreReady", true);
                  _logger["default"].success("Initialization done", "Module is now ready", "Core");
                }, 1500);
              }
              _context4.next = 10;
              break;
            case 9:
              _context4.prev = 9;
              _t4 = _context4["catch"](7);
              _logger["default"].error("ServiceNotification.Response", "Failed to process response from ".concat(message.origin, ": ").concat(_t4.message));
            case 10:
              return _context4.abrupt("return");
            case 11:
              if (this.myServices.includes(message.origin)) {
                _context4.next = 12;
                break;
              }
              console.warn("Ignoring SymmetricKeyExchange for: ".concat(message.origin));
              return _context4.abrupt("return");
            case 12:
              if (this.services[message.origin]) {
                _context4.next = 13;
                break;
              }
              _logger["default"].error("SymmetricExchange", "Service ".concat(message.origin, " not found when receiving symmetric key"));
              return _context4.abrupt("return");
            case 13:
              _logger["default"].debug("SymmetricExchange", "Service ".concat(message.origin, " data:"), this.services[message.origin]);
              _context4.prev = 14;
              _logger["default"].debug("SymmetricExchange", "Attempting to decrypt data from ".concat(message.origin, ", data length: ").concat(message.data.length));
              _context4.next = 15;
              return crypto.subtle.decrypt({
                name: "RSA-OAEP"
              }, this.cryptoKey.privateKey, _helpers["default"].base64ToArrayBuffer(message.data));
            case 15:
              decryptedData = _context4.sent;
              enc = new TextDecoder("utf-8");
              decryptedObject = JSON.parse(enc.decode(decryptedData));
              this.services[message.origin].symmetricKey = decryptedObject.symmetricKey;
              _logger["default"].debug("SymmetricExchange", "Stored symmetric key for ".concat(message.origin, ":"), decryptedObject.symmetricKey);
              _logger["default"].success("SymmetricExchange", "Exchange complete", message.origin);
              if (message.origin === "relay" && !this.coreReady) {
                this.coreReady = true;
                this.trigger("coreReady", true);
                _logger["default"].success("Core", "Relay symmetric key exchanged — core is now fully ready.");
              }
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
              }
              _context4.next = 17;
              break;
            case 16:
              _context4.prev = 16;
              _t5 = _context4["catch"](14);
              _logger["default"].error("SymmetricExchange", "Failed to decrypt: " + _t5.message, message.origin);
            case 17:
              return _context4.abrupt("return");
            case 18:
              if (this.myServices.includes(message.origin)) {
                _context4.next = 19;
                break;
              }
              console.warn("Ignoring ServiceNotification for: ".concat(message.origin));
              return _context4.abrupt("return");
            case 19:
              _context4.prev = 19;
              data = JSON.parse(message.data); // Update service data including publicKey and serviceIdentification
              // Clear the old symmetric key to force a fresh key exchange
              this.services[message.origin] = _objectSpread(_objectSpread({}, this.services[message.origin]), {}, {
                publicKey: data.publicKey,
                serviceIdentification: data.serviceIdentification,
                serviceAbbreviation: data.serviceAbbreviation,
                symmetricKey: null // Clear old symmetric key
              });
              _logger["default"].debug("ServiceNotification", "Stored service data for ".concat(message.origin, ":"), this.services[message.origin]);

              // Import the new public key into encryptionKey
              _context4.next = 20;
              return crypto.subtle.importKey("spki", _helpers["default"].pemToArrayBuffer(data.publicKey), {
                name: "RSA-OAEP",
                hash: "SHA-256"
              }, true, ["encrypt"]);
            case 20:
              this.services[message.origin].encryptionKey = _context4.sent;
              _context4.next = 21;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(data.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 21:
              _logger["default"].info("ServiceNotification", "Sent ServiceNotification.Response to ".concat(message.origin, " with updated public key"));

              // WORKAROUND: Force the relay to update our public key by sending another ServiceNotification
              // This is needed because the relay seems to cache old public keys
              setTimeout(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                return _regenerator["default"].wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 1;
                      return _this2.connection.invoke('messaging', {
                        uuid: (0, _uuid.v4)(),
                        action: "System.ServiceNotification",
                        requestUuid: "",
                        origin: "sdk-" + _this2.appName,
                        timestamp: Number(BigInt(Date.now()) * 1000000n),
                        data: JSON.stringify({
                          serviceIdentification: "System.SDK",
                          serviceAbbreviation: "sdk-" + _this2.appName,
                          publicKey: _this2.publicKey
                        })
                      });
                    case 1:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              })), 500); // Longer delay to ensure the response is processed first

              // Note: We don't start symmetric key exchange here because
              // the other service will initiate it after receiving our response
              _context4.next = 23;
              break;
            case 22:
              _context4.prev = 22;
              _t6 = _context4["catch"](19);
              _logger["default"].error("ServiceNotification", "Failed handling ServiceNotification from ".concat(message.origin, ": ").concat(_t6.message));
            case 23:
              return _context4.abrupt("return");
            case 24:
              return _context4.abrupt("continue", 25);
            case 25:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[7, 9], [14, 16], [19, 22]]);
      }));
      function handleMessage(_x2) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "startSymmetricKeyExchange",
    value: function () {
      var _startSymmetricKeyExchange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(origin) {
        var service, fernetKey, fernetKeyBase64, symmetricExchangeData, encryptedByteArray, encryptedData, symmetricExchangePayload, _t7;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.myServices.includes(origin)) {
                _context5.next = 1;
                break;
              }
              console.warn("Skipping symmetric key exchange for: ".concat(origin));
              return _context5.abrupt("return");
            case 1:
              service = this.services[origin];
              if (service) {
                _context5.next = 2;
                break;
              }
              console.error("ERROR: Service '".concat(origin, "' not found before key exchange!"));
              return _context5.abrupt("return");
            case 2:
              _context5.prev = 2;
              _context5.next = 3;
              return crypto.subtle.importKey("spki", _helpers["default"].pemToArrayBuffer(service.publicKey), {
                name: "RSA-OAEP",
                hash: "SHA-256"
              }, true, ["encrypt"]);
            case 3:
              service.encryptionKey = _context5.sent;
              // Generate a 32-byte Fernet key
              fernetKey = _helpers["default"].getRandomString(32); // Ensure this is 32 characters long
              fernetKeyBase64 = btoa(fernetKey); // Base64 encode the key
              service.symmetricKey = fernetKeyBase64; // Store it as base64

              // Prepare the symmetric key exchange payload
              symmetricExchangeData = JSON.stringify({
                'serviceAbbreviation': 'sdk-' + this.appName,
                'serviceIdentification': 'System.SDK',
                'symmetricKey': fernetKeyBase64
              }); // Encrypt the payload with the public key
              _context5.next = 4;
              return crypto.subtle.encrypt({
                name: "RSA-OAEP",
                hash: "SHA-256"
              }, service.encryptionKey, new TextEncoder().encode(symmetricExchangeData));
            case 4:
              encryptedByteArray = _context5.sent;
              encryptedData = String.fromCharCode.apply(null, new Uint8Array(encryptedByteArray));
              symmetricExchangePayload = {
                'uuid': (0, _uuid.v4)(),
                'action': "".concat(service.serviceIdentification, ".SymmetricKeyExchange"),
                'origin': 'sdk-' + this.appName,
                'timestamp': Number(BigInt(Date.now()) * 1000000n),
                'data': btoa(encryptedData) // Base64-encoded encrypted data
              };
              _logger["default"].debug("SymmetricExchange", "Sending symmetric key exchange to ".concat(origin));
              _context5.next = 5;
              return this.connection.invoke("messaging", symmetricExchangePayload);
            case 5:
              _logger["default"].success("SymmetricExchange", "Key exchange successful for ".concat(origin));
              _context5.next = 7;
              break;
            case 6:
              _context5.prev = 6;
              _t7 = _context5["catch"](2);
              _logger["default"].error("SymmetricExchange", "Failed to exchange keys with ".concat(origin, ". Error: ").concat(_t7.message));
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[2, 6]]);
      }));
      function startSymmetricKeyExchange(_x3) {
        return _startSymmetricKeyExchange.apply(this, arguments);
      }
      return startSymmetricKeyExchange;
    }()
  }, {
    key: "deviceState",
    value: function deviceState() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var uuid = (0, _uuid.v4)();
        var payload = {
          uuid: uuid,
          requestUuid: "",
          action: "System.Relay.State",
          origin: "sdk-" + _this3.appName,
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          data: "{}"
        };
        _this3.connection.invoke("messaging", payload).then(function () {
          _this3.connection.on("messaging", function (msg) {
            if (msg.action === "System.Relay.State.Response" && msg.requestUuid === uuid) {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "getDisplayApplication",
    value: function getDisplayApplication() {
      var _this4 = this;
      return new Promise(function (resolve) {
        var uuid = (0, _uuid.v4)();
        var payload = {
          uuid: uuid,
          requestUuid: "",
          action: "System.Relay.DisplayApplications",
          origin: "sdk-" + _this4.appName,
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          data: "{}"
        };
        _this4.connection.invoke("messaging", payload).then(function () {
          _this4.connection.on("messaging", function (msg) {
            if (msg.action === "System.Relay.DisplayApplications.Response" && msg.requestUuid === uuid) {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "connect",
    value: function () {
      var _connect = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var exportedKey, notificationUuid;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return crypto.subtle.generateKey({
                name: "RSA-OAEP",
                modulusLength: 2048,
                publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
                hash: {
                  name: "SHA-256"
                }
              }, true, ["encrypt", "decrypt"]);
            case 1:
              this.cryptoKey = _context6.sent;
              _context6.next = 2;
              return crypto.subtle.exportKey("spki", this.cryptoKey.publicKey);
            case 2:
              exportedKey = _context6.sent;
              this.publicKey = _helpers["default"].spkiToPEM(exportedKey);
              // Now, connect to LPSv2
              this.connection = new _signalr.HubConnectionBuilder().withUrl(this.url).withAutomaticReconnect().build();
              _context6.next = 3;
              return this.connection.start({
                withCredentials: false
              });
            case 3:
              _logger["default"].info("Connection", "LPSv2 connected v5.13.5, sending ServiceNotification", "LPS");
              // Send to other modules that we are connected
              this.trigger('connection', true);
              this.connection.serverTimeoutInMilliseconds = 30000; // 30 second timeout
              this.connection.keepAliveIntervalInMilliseconds = 5000;
              // Handle 
              this.connection.on("messaging", this.handleMessage.bind(this));

              // Send a ServiceNotification to LPSv2
              this.serviceNotificationTimestamp = Number(BigInt(Date.now()) * 1000000n);
              notificationUuid = (0, _uuid.v4)();
              this.lastServiceNotificationRequestUuid = notificationUuid;
              _context6.next = 4;
              return this.connection.invoke('messaging', {
                uuid: notificationUuid,
                action: "System.ServiceNotification",
                requestUuid: "",
                // intentionally empty
                origin: "sdk-" + this.appName,
                timestamp: this.serviceNotificationTimestamp,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 4:
              _logger["default"].info("ServiceNotification", "I've sent a ServiceNotification to LPSv2 containing my Public key", "LPS");
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
  }]);
}();